import React from 'react';

import {trackEvent} from 'analytics/Analytics';
import {INSIGHTS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {getParameterConfigsSpecFromReadShape} from 'insights/analytics-dashboards/RESTAnalyticsDashboardTypes';
import {AnalyticsParameterValue} from 'insights/parameters/__generated/AnalyticsParameterValue';
import {convertGQLToRESTParameterValue} from 'insights/parameters/data/ParameterGQLRESTConverters';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import runModal from 'ui-library/runModal';

import {AnalyticsParameterConfigGraphQL} from '../../../../graphql-fragments/insights/__generated/AnalyticsParameterConfigGraphQL';
import SQLAssistantModal from './SQLAssistantModal';

export interface SQLAssistantButtonProps {
  draftSQLQuery: string;
  parameterConfigs: Array<AnalyticsParameterConfigGraphQL>;
  parameterValues: Array<AnalyticsParameterValue>;
  setDraftSQLQuery: (sql: string) => void;
  saveAndRunQuery: (sql: string) => void;
}

export default function SQLAssistantButton(props: SQLAssistantButtonProps): JSX.Element {
  return (
    <Tooltip title="SQL assistant" placement={TooltipPlacement.TOP}>
      <Button
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        size={ButtonSize.MINI}
        icon="magic-wand"
        onClick={() => {
          trackEvent(INSIGHTS_ANALYTICS_ACTIONS.OPENED_SQL_AI_ASSISTANT_MODAL);
          runModal(SQLAssistantModal, {
            draftSql: props.draftSQLQuery,
            parameterConfigs: getParameterConfigsSpecFromReadShape(props.parameterConfigs),
            parameterValues: props.parameterValues.map((value) => convertGQLToRESTParameterValue(value)),
            onAccept: (suggestedSQL: string) => {
              props.setDraftSQLQuery(suggestedSQL);
              props.saveAndRunQuery(suggestedSQL);
            },
          });
        }}
      />
    </Tooltip>
  );
}
